import {
  isPossiblePhoneNumber,
  parsePhoneNumber,
} from 'libphonenumber-js';

const normalizePhoneInput = (input) => {
  if (input === null || input === undefined) {
    return '';
  }
  return String(input).trim();
};

export const normalizePhoneNumber = (input, defaultCountry = 'US') => {
  const raw = normalizePhoneInput(input);
  if (!raw) {
    return {
      isValid: true,
      e164: null,
    };
  }
  if (!isPossiblePhoneNumber(raw, defaultCountry)) {
    return {
      isValid: false,
      e164: null,
    };
  }
  try {
    const parsed = parsePhoneNumber(raw, defaultCountry);
    return {
      isValid: true,
      e164: parsed.number,
    };
  } catch (error) {
    return {
      isValid: false,
      e164: null,
    };
  }
};
